'use strict';

var ChartsPlugin = require('utils/charts/charts_plugin');
var ChartsZoomButtons = ChartsPlugin.extend({
    zoomFactor: 0.7,
    ui: {
        btnZoomXIn: '.js-chart-zoom-in',
        btnZoomXOut: '.js-chart-zoom-out',
        btnZoomYIn: '.js-chart-zoom-y-in',
        btnZoomYOut: '.js-chart-zoom-y-out',
        btnZoomReset: '.js-chart-zoom-reset',
    },

    initPlugin: function () {
        var self = this;
        $(this.ui.btnZoomXIn).on('click', function () {
            self.zoomX(true);
        });
        $(this.ui.btnZoomXOut).on('click', function () {
            self.zoomX(false);
        });
        $(this.ui.btnZoomYIn).on('click', function () {
            self.zoomY(true);
        });
        $(this.ui.btnZoomYOut).on('click', function () {
            self.zoomY(false);
        });
        $(this.ui.btnZoomReset).on('click', function () {
            self.zoomReset();
        });
        this.chartView.on('charts:draw:after', function () {
            self.toggleEnabled();
        });
    },

    calculateZoom: function (zoomData, zf, maxRange) {
        var x1 = zoomData[0];
        var x2 = zoomData[1];

        var c = (x1 + x2) / 2;
        var d = (x2 - x1) / 2;

        return [Math.max(Math.floor(c - zf * d), maxRange[0]), Math.min(Math.ceil(c + zf * d), maxRange[1])];
    },

    toggleEnabled: function () {
        // keine Daten: alles deaktivieren
        var hasData = !this.data.isEmpty();
        $(this.ui.btnZoomXIn).attr('disabled', hasData ? null : 'true');
        $(this.ui.btnZoomXOut).attr('disabled', hasData && this.canZoomXOut() ? null : 'true');
        $(this.ui.btnZoomYIn).attr('disabled', hasData && this.canZoomYIn() ? null : 'true');
        $(this.ui.btnZoomYOut).attr('disabled', hasData && this.canZoomYOut() ? null : 'true');
        $(this.ui.btnZoomReset).attr('disabled', hasData ? null : 'true');
        this.view.removeDisabledTooltips();
    },

    canZoomXOut: function () {
        var canZoom = false;

        this.foreachCharts(function (key, g) {
            var dateWindow = this.getDateWindow(g);
            var maxDateWindow = this.getDateMaxWindow(g);

            if (dateWindow && maxDateWindow) {
                canZoom = canZoom || dateWindow[0] > maxDateWindow[0] || dateWindow[1] < maxDateWindow[1];
            }
        });

        return canZoom;
    },

    canZoomYIn: function () {
        var canZoom = false;

        this.foreachCharts(function (key, g) {
            if (g.trovisContext && g.trovisContext.isBinary) return;

            var valueWindow = this.getValueWindow(g);
            var maxValueWindow = this.getValueMaxWindow(g);

            if (maxValueWindow != undefined && valueWindow != undefined) {
                var newValues = this.calculateZoom(valueWindow, this.zoomFactor, maxValueWindow);
                canZoom = canZoom || newValues[0] != valueWindow[0] || newValues[1] != valueWindow[1];
            }
        });

        return canZoom;
    },

    canZoomYOut: function () {
        var canZoom = false;

        var fits = function (min, max, currentMinOrMax, isMax) {
            var diff = max - min;
            var relDiff = (currentMinOrMax - min) / diff;
            var tolerance = 0.0001;

            return isMax ? relDiff < 1 - tolerance : relDiff > tolerance;
        };

        this.foreachCharts(function (key, g) {
            var valueWindow = this.getValueWindow(g);
            var maxValueWindow = this.getValueMaxWindow(g);

            if (valueWindow && maxValueWindow) {
                canZoom =
                    canZoom ||
                    fits(maxValueWindow[0], maxValueWindow[1], valueWindow[0], false) ||
                    fits(maxValueWindow[0], maxValueWindow[1], valueWindow[1], true);
            }
        });

        return canZoom;
    },

    zoomX: function (isIn) {
        this.foreachCharts(function (key, value) {
            var dateWindow = this.getDateWindow(value);
            dateWindow = this.calculateZoom(
                dateWindow,
                isIn ? this.zoomFactor : 1 / this.zoomFactor,
                this.getDateMaxWindow(value)
            );
            value.updateOptions({
                dateWindow: dateWindow,
                valueWindow: this.getValueWindow(value),
            });
        });
        this.toggleEnabled();
    },

    zoomY: function (isIn) {
        this.foreachCharts(function (key, value) {
            if (value.trovisContext && value.trovisContext.isBinary) {
                return;
            }

            var valueWindow = this.getValueWindow(value);
            valueWindow = this.calculateZoom(
                valueWindow,
                isIn ? this.zoomFactor : 1 / this.zoomFactor,
                this.getValueMaxWindow(value)
            );

            value.updateOptions({
                valueWindow: valueWindow,
            });
        });
        this.toggleEnabled();
    },

    zoomReset: function () {
        this.foreachCharts(function (key, value) {
            value.updateOptions({
                dateWindow: this.getDateMaxWindow(value),
                valueWindow: this.getValueMaxWindow(value),
            });
        });
    },
});

module.exports = ChartsZoomButtons;
